module.exports = __webpack_public_path__ + "img/commission2.e55e8cbf.webp";